/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Student_Payments_EmptyInputs */

const en_student_payments_empty = /** @type {(inputs: Student_Payments_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No payments recorded.`)
};

const he_student_payments_empty = /** @type {(inputs: Student_Payments_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`לא נרשמו תשלומים.`)
};

/**
* | output |
* | --- |
* | "No payments recorded." |
*
* @param {Student_Payments_EmptyInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const student_payments_empty = /** @type {((inputs?: Student_Payments_EmptyInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Student_Payments_EmptyInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_student_payments_empty(inputs)
	return he_student_payments_empty(inputs)
});